import { render, staticRenderFns } from "./RegisterDocuments.vue?vue&type=template&id=5c5307b6&scoped=true"
import script from "./RegisterDocuments.vue?vue&type=script&lang=js"
export * from "./RegisterDocuments.vue?vue&type=script&lang=js"
import style0 from "./RegisterDocuments.vue?vue&type=style&index=0&id=5c5307b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5307b6",
  null
  
)

export default component.exports